import { signal } from '@angular/core';
import { localStorageOrganizationIdKey } from '../utils/local-storage.utils';

// Hack to avoid circular dependency of global.store vs. indexedDb... maybe others as well
export const currentUserId = signal('');

export const selectedOrganizationId = signal<number>(
    Number(localStorage.getItem(localStorageOrganizationIdKey) || 0),
);
